(function () {
  if (window.__cnPdpDisclosuresInitialized) return;
  window.__cnPdpDisclosuresInitialized = true;

  var desktopQuery = window.matchMedia("(min-width: 990px)");
  var isSyncing = false;

  function syncDisclosureDefaults() {
    var disclosures = document.querySelectorAll("[data-cn-pdp-disclosure]");
    isSyncing = true;
    disclosures.forEach(function (disclosure) {
      if (disclosure.dataset.cnPdpUserToggled === "true") return;
      disclosure.open = desktopQuery.matches;
    });
    window.setTimeout(function () {
      isSyncing = false;
    }, 0);
  }

  document.addEventListener(
    "toggle",
    function (event) {
      if (isSyncing || !event.target.matches("[data-cn-pdp-disclosure]")) return;
      event.target.dataset.cnPdpUserToggled = "true";
    },
    true,
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncDisclosureDefaults, { once: true });
  } else {
    syncDisclosureDefaults();
  }

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener("change", syncDisclosureDefaults);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(syncDisclosureDefaults);
  }
})();
